export const SettingsURL = "https://backend.redi-home.com/api";
export const BackendImageURL =
  "https://redihomecdn.fra1.cdn.digitaloceanspaces.com";
